import { Row } from "antd";
import React from "react";
import { IGrayRowProps } from "./interface";

const ZGrayRow: React.FC<IGrayRowProps> = ({
	className,
	children,
	...rest
}) => {
	// let newClassName = `p-3 mb-4 rounded-lg bg-gray-3 text-1`;
	let newClassName = `p-3 mb-4 rounded-lg bg-gray-3 text-1`;
	const marginBottomPattern = /(^|\s)mb-(\d+)($|\s)/g;
	if (className) {
		if (marginBottomPattern.test(className))
			newClassName = `${newClassName.replace(
				/(^|\s)mb-(\d*)($|\s)/g,
				"$1$3"
			)}`;
		newClassName += ` ${className}`;
	}
	return (
		<Row className={newClassName} {...rest}>
			{children}
		</Row>
	);
};

export default ZGrayRow;
